// CONSTANTS are all caps.
const NS = 'SearchLocationMapBlock';
const CLS = 'searchLocationMapBlock';
const BLK = '.' + CLS + '-';

const NumberOfVisibleItems = 5;

/* global google*/
import $ from 'jquery';
import handlebars from 'handlebars';
import {GoogleMapsApi} from 'global/js/googleMapsApi';
import * as Api from '../../../../global/js/api';
import 'select2';

export class SearchLocationMapBlock {
	constructor($el) {
		this.$el = $el;
		this.latLangs = [];
		// this.markers = [];
		this.gMapLatLangs = [];
		// ////////
		this.allMarkers = [];
		this.currenySearchMarkers = [];
		this.latLngBounds = {
			north: 20,
			south: -44.00,
			east: 170.884,
			west: 112.974,
		};
	}

	init() {
		this.$locationSearchBlock = $(`.${CLS}`);
		this.jsonObject = this.$locationSearchBlock.data('json');
		this.searchCommunityInput = $('#community-form-control');
		this.searchLocationInput = $(`#${CLS}-input`);

		const query = require('url').parse(window.location.href, true).query;
		this.forcedTab = query.mapTab;

		handlebars.registerHelper('ifCond', (v1, operator, v2, options) => {
			switch (operator) {
				case '==':
					return v1 == v2 ? options.fn(this) : options.inverse(this);
				case '!=':
					return v1 != v2 ? options.fn(this) : options.inverse(this);
				default:
					return options.inverse(this);
			}
		});

		this.initMap();
		this.initLocationSearchAutoComplete();
		this.initKeywordSearchAutoComplete();
		this.initSelect2();
	}

	initLocationSearchAutoComplete() {
		$(document).on('click', (e) => {
			const container = $(`${BLK}container`);
			// if the target of the click isn't the container nor a descendant of the container
			if (
				!container.is(e.target) &&
				container.has(e.target).length === 0
			) {
				this.toggleResults(false);
				this.toggleKeywordResults(false);
				this.searchLocationInput.val(this.selectedLocation.label);
			}
			e.stopPropagation();
		});

		this.searchLocationResults = $(`${BLK}results`);
		this.searchLocationName = $(`${BLK}location-name`);
		this.searchLocation = $(`${BLK}location`);
		this.searchLocationNearby = $(`${BLK}nearby-locations`);
		this.gmapApi.load().then(() => {
			this.searchLocationInput.on('input', (e) => {
				this.inputEvent();
			});
		});
		this.selectedLocation = {
			lat: '',
			lng: '',
			label: '',
		};
	}

	initSearchInput(initLoad) {
		
		this.debounceSearchLocationService = this.debounce(
			this.searchLocationService
		);

		const query = require('url').parse(window.location.href, true).query;
		if (query.location != null && query.location != '' && initLoad) {
			this.location = query.location;

			this.searchLocationInput.val(this.location);

			this.gmapApi.load().then(() => {
				this.inputEvent(true);
			});
		}
	}

	debounce(func, timeout = 400) {
		let timer;
		return (...args) => {
			clearTimeout(timer);
			timer = setTimeout(() => {
				func.apply(this, args);
			}, timeout);
		};
	}

	inputEvent(selectFirst) {
		this.searchLocationKeyword = this.searchLocationInput.val();
		if (this.searchLocationKeyword == '') {
			this.selectedLocation = {
				lat: '',
				lng: '',
				label: '',
			};
		}
		let isPostcode = this.isPostcode(this.searchLocationKeyword);
		let request = {};

		if (isPostcode) {
			request = {
				input:
					this.searchLocationKeyword == ''
						? ' '
						: this.searchLocationKeyword,
				componentRestrictions: {country: 'au'},
				types: ['(regions)'],
			};
		} else {
			request = {
				input:
					this.searchLocationKeyword == ''
						? ' '
						: this.searchLocationKeyword,
				componentRestrictions: {country: 'au'},
			};
		}

		this.keyword = request.input;
		this.debounceSearchLocationService(request, selectFirst);
	}

	searchLocationService(request, selectFirst) {
		let service = new google.maps.places.AutocompleteService();
		let geocoder = new google.maps.Geocoder();

		service.getPlacePredictions(request, (results, status) => {
			if (status == 'OK') {
				/**
				 * get closet prediction of location, use this location geocode for properties list search
				 */
				this.toggleResults(true);
				this.searchLocationName.text(results[0].description);
				this.searchLocation.attr(
					'data-location-lable',
					results[0].description
				);
				this.searchLocation.attr('data-place-id', results[0].place_id);

				geocoder.geocode(
					{
						placeId: results[0].place_id,
					},
					(responses, status) => {
						if (status == 'OK') {
							const lat = responses[0].geometry.location.lat();
							const lng = responses[0].geometry.location.lng();

							let geoLocation = {
								lat,
								lng,
							};

							let keyword = {
								keyword: this.searchLocationKeyword,
							};

							let json = {
								location: geoLocation,
							};
							json = JSON.stringify(json);
							this.searchLocation.attr('data-json', json);
							this.searchLocation.attr('data-lat', lat);
							this.searchLocation.attr('data-lng', lng);
							this.selectedLocation = {
								lat: lat,
								lng: lng,
								label: results[0].description,
							};
						}
					}
				);
				this.renderLocationResults(results, selectFirst);
				this.setLocationsClickListener();
			} else {
				this.toggleResults(false);
			}
		});
	}

	setLocationsClickListener() {
		if (
			this.locationsEventListeners &&
			this.locationsEventListeners.length
		) {
			this.locationsEventListeners.off();
		}

		this.locationsEventListeners = $('[data-place-id]').on('click', (e) => {
			this.selectedLocation = {
				lat: e.currentTarget.dataset.lat,
				lng: e.currentTarget.dataset.lng,
				label: e.currentTarget.dataset.locationLable,
			};
			this.searchLocationInput.val(e.currentTarget.dataset.locationLable);
			this.toggleResults(false);
			e.stopPropagation();
			this.fetchAndSetAllLocations(false, false);
		});
	}

	renderLocationResults(locationResponses, selectFirst) {
		this.searchLocationNearby.empty();
		let geocoder = new google.maps.Geocoder();

		for (let g = 1; g < locationResponses.length && g < 3; g++) {
			let locationLink = $('<div></div>')
				.addClass(
					`${CLS}-one-nearby-location text-decoration-none d-block`
				)
				.html(
					`<div class="d-flex align-items-center text-very-dark-grey py-2 py-lg-3 mx-2">
									<span class="icon-location text-salmon fs-2"></span>
									<span class="${CLS}-location-name ml-3">${locationResponses[g].description}</span>
								</div>`
				)
				.attr('data-location-lable', locationResponses[g].description)
				.attr('data-place-id', locationResponses[g].place_id);

			this.searchLocationNearby.append(locationLink);
			geocoder.geocode(
				{
					placeId: locationResponses[g].place_id,
				},
				(responses, status) => {
					if (status == 'OK') {
						const lat = responses[0].geometry.location.lat();
						const lng = responses[0].geometry.location.lng();
						const locationItem = $(
							`[data-place-id="${locationResponses[g].place_id}"]`
						);
						locationItem.attr('data-lat', lat);
						locationItem.attr('data-lng', lng);
						if (selectFirst === true) {
							$('[data-place-id]').first().trigger('click');
						}
					}
				}
			);
		}
	}

	// //////////////////////

	initKeywordSearchAutoComplete() {
		// $(document).on("click", (e) => {
		// 	const container = $(`${BLK}container`);
		// 	// if the target of the click isn't the container nor a descendant of the container
		// 	if (
		// 		!container.is(e.target) &&
		// 		container.has(e.target).length === 0
		// 	) {
		// 		this.toggleResults(false);
		// 		this.searchCommunityInput.val(this.selectedKeyword);
		// 	}
		// 	e.stopPropagation();
		// });
		this.searchCommunityLocationResults = $(`${BLK}community-results`);
		this.searchCommunityLocationName = $(`${BLK}community-location-name`);
		this.searchCommunity = $(`${BLK}community-location`);
		this.searchCommunityNearby = $(`${BLK}community-nearby-locations`);


		this.debounceSearchKeywordService = this.debounce(
			this.getNearbyProperties
		);

		this.searchCommunityInput.on('input', (e) => {
			this.inputKeywordEvent();
		});
	}


	inputKeywordEvent() {
		let keyword = {
			'keyword': this.searchCommunityInput.val(),
		};

		this.debounceSearchKeywordService(keyword);
	}


	setKeywordClickListener() {
		if (
			this.locationsEventListeners &&
			this.locationsEventListeners.length
		) {
			this.locationsEventListeners.off();
		}
		this.locationsEventListeners = $('[data-keyword]').on('click', (e) => {
			this.selectedLocation = {
				lat: e.currentTarget.dataset.lat,
				lng: e.currentTarget.dataset.lng,
				label: e.currentTarget.dataset.locationLable,
			};
			this.searchLocationInput.val(e.currentTarget.dataset.locationLable);
			this.toggleKeywordResults(false);
			e.stopPropagation();
		});
	}


	getNearbyProperties(keyword) {
		/**
		 * call api services get nearby properties;
		 */

		this.fetchResults(this.locationKeywordUrl, keyword).then((response) => {
			if (response &&
				response.data &&
				response.data.length > 0) {
				this.renderKeywordResults(response.data);
			} else {
				this.renderKeywordResults([]);
				console.log('return response is null');
			}
		});
	}


	renderKeywordResults(nearbyProperties) {
		if (nearbyProperties.length === 0) {
			return;
		}
		this.searchCommunityNearby.empty();
		for (let i = 0; i < nearbyProperties.length; i++) {
			var image = 'house.svg';

			switch(nearbyProperties[i].type){
				case 'residentialagedcare':
					image = 'residential.svg';
				break;
				case 'retirementliving':
					image = 'retirement.svg';
				break;
			}

			let locationLink = $('<a></a>')
				.addClass(`text-decoration-none`)
				.html(`<div class="d-flex align-items-center ${CLS}-results-item text-very-dark-grey py-2 py-lg-3 mx-2">
				<image src='/assets/svgs/${image}' />
				<span class="ml-3">${nearbyProperties[i].name}</span>
			</div>`)
				.attr('data-keyword', nearbyProperties[i].name);

			this.searchCommunityNearby.append(locationLink);

			locationLink.on('click', (e) => {
				this.searchCommunityInput.val(nearbyProperties[i].name);
				this.searchCommunityLocationResults.addClass('d-none');
			});
		}

		this.toggleKeywordResults(true);
	}

	// //////////////////////

	fetchResults(url, $filterParam) {
		let paramsString = this.getFilters($filterParam);
		let apiUrl = url + '?' + paramsString;

		return Api.getApi(apiUrl);
	}

	isPostcode(input) {
		if (isNaN(Number(input))) {
			return false;
		}
		return true;
	}

	toggleResults(isOpen) {
		/**
		 * open or close dropdown prediction list UI
		 */
		isOpen
			? this.searchLocationResults.removeClass('d-none')
			: this.searchLocationResults.addClass('d-none');
	}

	toggleKeywordResults(isOpen) {
		/**
		 * open or close dropdown prediction list UI
		 */
		isOpen
			? this.searchCommunityLocationResults.removeClass('d-none')
			: this.searchCommunityLocationResults.addClass('d-none');
	}
	//


	initMap() {
		let that = this;
		if (window.gmapApi) {
			this.gmapApi = window.gmapApi;
		} else {
			window.gmapApi = new GoogleMapsApi();
			this.gmapApi = window.gmapApi;
		}
		this.setMap();

		this.apiUrl = this.jsonObject.apiUrl;
		this.locationKeywordUrl = this.jsonObject.locationKeywordUrl;

		$(`${BLK}search-form`).off('submit').on('submit', (e) => {
			e.preventDefault();
			this.fetchAndSetAllLocations(false, false);
			return false;
		});

		$(document).on("search-bar-searched", function (e, searchValue) {
			that.searchLocationInput.val(searchValue);
			that.inputEvent(true);
			this.fetchAndSetAllLocations(false, false);
		});
	}

	/**
	 * As handlebar doesn't support data manipulation extra flags are
	 * added here.
	 *
	 * In particular:
	 *     {
	 *			"group": "All",
	 *  		"groupKey": "All",
	 *			"selected": true,
	 *			"hasShowMore": true
	 *			"items": [
	 *				{
	 *					"hide": true
	 *				},
	 *
	 *			]
	 *		},
	 *
	 * @see fetchAndSetAllLocations
	 * @see setLocationTabData
	 */
	updateData(locations) {
		function isAfterThirdRow(index) {
			return index > NumberOfVisibleItems;
		}

		function addHideItem(item) {
			item.hide = true;
			return item;
		}

		function hiderAfterThirdRow(item, index) {
			return isAfterThirdRow(index)
						? addHideItem(item)
						: item
		}

		function addShowMoreAfterThirdRow(grp) {
			grp.hasShowMore = true;
			grp.items = grp.items.map(hiderAfterThirdRow)

			return grp;
		}

		function isGroupWithShowMore(grp) {
			return grp.hasShowMore = grp.items.length > NumberOfVisibleItems
			//return ['all'].indexOf(grp.groupKey.toLowerCase()) > -1;
		}


		return locations.map((grp) => isGroupWithShowMore(grp) ? addShowMoreAfterThirdRow(grp) : grp);
	}

	/**
	 * Show cards and hide button
	 *
	 * @see fetchAndSetAllLocations
	 */
	initTabShowMoreCards() {
		const _self = this;
		const btnList = Array.from(this.$el.querySelectorAll(`.${CLS}-tabShowMoreCards`));

		function showAllTheCard(target) {
			Array
				.from(_self.$el.querySelectorAll(`#${target} .d-none`))
				.forEach((itm) => itm.classList.remove('d-none'));
		}

		function hideButton(btn) {
			btn.parentElement.classList.add('d-none');
		}

		function onClick(btn) {
			const showCardHideBtn = () =>
										( showAllTheCard(btn.dataset.target)
										, hideButton(btn));
			btn.addEventListener('click', showCardHideBtn);
		}

		btnList.forEach(onClick);
	}

	/**
	 * Show cards and hide button
	 *
	 * skipZoomToMarkers is true on first load and initilization
	 */
	fetchAndSetAllLocations(skipZoomToMarkers, initInput) {
		if (skipZoomToMarkers == null) {
			skipZoomToMarkers = false;
		}

		if (initInput == null) {
			initInput = false;
		}

		this.cleanMarkers();
		if (this.groupTabLinks && this.groupTabLinks.length) {
			this.groupTabLinks.off();
		}
		$(this.$el).find(`${BLK}tabContainer ul`).empty();
		$(this.$el).find(`${BLK}tabContent`).empty();
		// const filters = {
		// 	// lat: this.selectedLocation.lat,
		// 	// lng: this.selectedLocation.lng,
		// 	// label: this.selectedLocation.label,
		// 	// keyword: $("#community-form-control").val(),
		// 	// state: '',
		// };

		const filters = {
			lat: this.selectedLocation.lat,
			lng: this.selectedLocation.lng,
			label: this.selectedLocation.label,
			keyword: $('#community-form-control').val(),
			state: $('#dropDown-form-control').val(),
			respiteType: $('#selectType').val(),
			forcedTab : this.forcedTab
		};

		this.forcedTab = '';
		const checkboxesContainer = $(`${BLK}searchLocationCheckBox`);
		if (checkboxesContainer.length) {
			const checkBoxes = $(checkboxesContainer).find(
				`${BLK}form-check-input`
			);
			const checkBoxValues = [];
			checkBoxes.map((checkBoxIndex) => {
				const checkBox = checkBoxes[checkBoxIndex];
				if (checkBox.checked) {
					checkBoxValues.push(checkBox.value);
				}
			});
			filters.serviceType = checkBoxValues.join(',');
		}

		this.fetchLocations(this.apiUrl, filters).then((locations) => {
			locations = this.updateData(locations);
			this.setLocationTabs(locations);
			this.setLocationTabData(locations);
			this.initTabShowMoreCards();

			const tabContainer = $(`${BLK}tabContainer`);
			if (!locations || !locations.length) {
				tabContainer.addClass('d-none');
				tabContainer.removeClass('d-inline-flex');
				$(this.$el)
					.find(`${BLK}tabContent`)
					.html(
						'<p class="text-center mb-0">There is no item to show!<p/>'
					);
			} else {
				tabContainer.addClass('d-inline-flex');
				tabContainer.removeClass('d-none');
			}

			this.groupTabLinks = $(`.${CLS}-nav-link`);
			this.groupTabLinks.on('click', (event) => {
				this.selectItems(event.currentTarget.id);
				this.setMapExtendToSearch();
			});

			if (locations.length >= 0) {
				this.selectItems(`${locations[0].groupKey}-tab`);
			}

			this.generateMapData(skipZoomToMarkers);
			if (locations && locations.length) {
				const selectedItemIdx = locations.findIndex((l) => {
					return l.selected;
				});
				if (selectedItemIdx >= 0) {
					this.selectItems(`${locations[selectedItemIdx].groupKey}-tab`);
					this.setMapExtendToSearch();
				}
			}
			if (initInput) {
				this.initSearchInput(initInput);
			}
		});
	}


	setLocationTabs(locations) {
		let theTemplateScript = `
			{{#each items as |item|}}
				<li class="nav-item" role="presentation">
					<a
						class="${CLS}-nav-link nav-link {{# ifCond item.selected '==' true }}active{{/ifCond}}"
						id="{{item.groupKey}}-tab"
						data-toggle="tab"
						href="#{{item.groupKey}}-tab-contnet"
						role="tab"
						aria-controls="{{item.groupKey}}-tab-contnet"
						aria-selected="{{item.selected}}"
					>{{item.group}}</a>
				</li>
			{{/each}}
		`;

		let precompiled = new Function(
			'return ' + handlebars.precompile(theTemplateScript)
		)();
		const data = {
			items: locations,
		};
		let theTemplate = handlebars.template(precompiled);
		let theCompiledHtml = theTemplate(data);
		$(this.$el).find(`${BLK}tabContainer ul`).html(theCompiledHtml);
	}

	setLocationTabData(locations) {
		let theTemplateScript = `
		{{#each items as |groupItem|}}
			<div
			class="tab-pane fade {{# ifCond groupItem.selected '==' true }}show active{{/ifCond}}"
			id="{{groupItem.groupKey}}-tab-contnet"
			role="tabpanel"
			aria-labelledby="{{groupItem.groupKey}}-tab"
			>
				<div class="${CLS}-tabContentRow row">
					{{#each groupItem.items as |tabItem|}}
						<div class="${CLS}-locationCard col-md-6 col-xl-4 {{#if tabItem.hide}} d-none {{/if}}"
							data-latitude="{{tabItem.lat}}"
							data-longitude="{{tabItem.lon}}"
							data-title="{{tabItem.title}}"
							data-summary="{{tabItem.summary}}"
							data-suburb="{{tabItem.suburb}}"
							data-state="{{tabItem.state}}"
							data-image="{{tabItem.image.src}}"
							data-type="{{tabItem.type}}"
							data-link="{{tabItem.link}}"

							>
							<a
								class="${CLS}-tabContentCard d-flex align-items-center"
								href="{{tabItem.link}}"
							>
								<img
									title="{{tabItem.suburb}}, {{tabItem.state}}"
									src="{{tabItem.image.src}}"
									alt="{{tabItem.image.alt}}"
								/>
								<aside
									title="{{tabItem.suburb}}, {{tabItem.state}}"
									class="${CLS}-tabContentAside flex-1 h-100 d-flex flex-column justify-content-around"
								>
									<h5>
										{{tabItem.suburb}}, {{tabItem.state}}
									</h5>
									<div
										class="d-flex justify-content-between align-items-center"
									>
										<h4>{{tabItem.title}}</h4>
										<svg
											width="7"
											height="10"
											viewBox="0 0 7 10"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M6.70949 5.42439L6.71005 5.42386C6.92843 5.21754 6.92848 4.88163 6.71459 4.67516L6.7146 4.67515L6.71325 4.67389L2.2833 0.552574C2.2832 0.55248 2.2831 0.552385 2.283 0.552291C2.06767 0.349155 1.72178 0.34925 1.50657 0.552574L1.57525 0.625264L1.50657 0.552575L1.23954 0.80486C1.021 1.01133 1.021 1.34784 1.23954 1.5543L1.24018 1.55491L5.00496 5.0491L1.23646 8.54334L1.23646 8.54333L1.23578 8.54397C1.01724 8.75044 1.01724 9.08695 1.23578 9.29342L1.50281 9.5457C1.71803 9.74903 2.06391 9.74912 2.27925 9.54598C2.27934 9.54589 2.27944 9.54579 2.27954 9.5457L6.70949 5.42439Z"
												fill="#EA5167"
												stroke="#EA5167"
												stroke-width="0.2"
											></path>
										</svg>
									</div>
								</aside>
							</a>
						</div>
					{{/each}}

					{{#if groupItem.hasShowMore}}
						<div class="col-12 text-center">
							<button
								class="${CLS}-tabShowMoreCards btn text-normal btn-primary text-uppercase rounded cursor-pointer"
								data-target="{{groupItem.groupKey}}-tab-contnet">View all locations</button>
						</div>
					{{/if}}
				</div>
			</div>
		{{/each}}
		`;

		let precompiled = new Function(
			'return ' + handlebars.precompile(theTemplateScript)
		)();
		const data = {
			items: locations,
		};
		let theTemplate = handlebars.template(precompiled);
		let theCompiledHtml = theTemplate(data);
		$(this.$el).find(`${BLK}tabContent`).html(theCompiledHtml);
		// this.setMapInfoBlockSize();
	}

	fetchLocations(url, $filterParam) {
		let paramsString = this.getFilters($filterParam);
		let apiUrl = url + '?' + paramsString;

		return Api.getApi(apiUrl).then((locations) => {
			if (locations) {
				return locations.data;
			} else {
				return [];
			}
		});
	}

	getFilters(filterParam) {
		let keys = Object.keys(filterParam);
		let filters = '';
		for (let i = 0; i < keys.length; i++) {
			let key = keys[i];

			if (i === keys.length - 1) {
				filters += encodeURI(key) + '=' + encodeURI(filterParam[key]);
			} else {
				filters +=
					encodeURI(key) + '=' + encodeURI(filterParam[key]) + '&';
			}
		}

		return filters;
	}

	selectItems(id) {
		this.activeGroupTabLink = $(`.${CLS}-nav-link.active`);
		this.selectedLocationItems = $(
			`.${CLS}-tabContent .tab-pane#${id}-contnet .${CLS}-locationCard`
		);

		this.latLangs = this.selectedLocationItems.map(
			(selectedLocationItemIdx) => {
				const locationItem =
					this.selectedLocationItems[selectedLocationItemIdx];
				return {
					lat: locationItem.dataset.latitude,
					lng: locationItem.dataset.longitude,
					type: locationItem.dataset.type,
					image: locationItem.dataset.image,
					title: locationItem.dataset.title,
					summary: locationItem.dataset.summary,
					state: locationItem.dataset.state,
					suburb: locationItem.dataset.suburb,
					link: locationItem.dataset.link,
				};
			}
		)
			.toArray();
	}

	setMap() {
		this.gmapApi.load().then(() => {
			// safe to start using the API now
			this.gMap = google.maps;
			this.latLangs;
			const map = new google.maps.Map(
				document.querySelector(`#${CLS}-map`),
				{
					// zoom: 6,
					maxZoom: 15,
					styles: this.gmapApi.styles,
					disableDefaultUI: true,
					scaleControl: true,
					zoomControl: true,
					// restriction: {
					// 	latLngBounds: this.latLngBounds,
					// },
				}
			);
			this.map = map;
 			this.fetchAndSetAllLocations(false, true);
			let that = this;
			$(document).on('change', `${BLK}searchLocationCheckBox`, function() {
				that.fetchAndSetAllLocations(true, false);
			});
		});
	}

	generateMapData(skipZoomToMarkers) {
		this.cleanMarkers();
		const latlngbounds = new google.maps.LatLngBounds();
		this.gMapLatLangs = this.latLangs.map((item, itemIndex) => {
			const latlng = new google.maps.LatLng(
				+item.lat,
				+item.lng
			);
			if (item.lat != '0' && item.lng != '0') {
				latlngbounds.extend(latlng);
				return latlng;
			}
		});
		this.generateMarkers();
		if (skipZoomToMarkers === true) {
			return;
		}
		if (latlngbounds.getSouthWest().lat() ==
			latlngbounds.getNorthEast().lat() &&
			latlngbounds.getSouthWest().lng() ==
			latlngbounds.getNorthEast().lng()) {
			this.map.setZoom(17);
			this.map.panTo(latlngbounds.getCenter());
		} else {
			this.map.fitBounds(latlngbounds, 30);
			this.map.fitBounds(latlngbounds, 30);
		}
	}

	setMapExtendToSearch() {
		if (this.latLangs.length == 0) {
			const latlngbounds = new google.maps.LatLngBounds(
				new google.maps.LatLng(this.latLngBounds.north, this.latLngBounds.east),
				new google.maps.LatLng(this.latLngBounds.south, this.latLngBounds.west)
			);
			this.map.fitBounds(latlngbounds, 30);
			return;
		}
		const latlngbounds = new google.maps.LatLngBounds();
		this.gMapLatLangs = this.latLangs.map((item, itemIndex) => {
			const latlng = new google.maps.LatLng(
				+item.lat,
				+item.lng
			);
			if (item.lat != '0' && item.lng != '0') {
				latlngbounds.extend(latlng);
				return latlng;
			}
		});
		if (latlngbounds.getSouthWest().lat() ==
			latlngbounds.getNorthEast().lat() &&
			latlngbounds.getSouthWest().lng() ==
			latlngbounds.getNorthEast().lng()) {
			this.map.setZoom(17);
			this.map.panTo(latlngbounds.getCenter());
		} else {
			this.map.fitBounds(latlngbounds, 30);
			this.map.fitBounds(latlngbounds, 30);
		}
	}

	cleanMarkers() {
		this.allMarkers.map((item, itemIndex) => {
			// this.allMarkers[itemIndex].setMap(null);
			item.setMap(null);
		});
		this.allMarkers = [];
	}

	generateMarkers() {
		this.allMarkers = this.gMapLatLangs.map((item, index) => {
			this.infoWindow_ = new google.maps.InfoWindow();

			let iconName = this.latLangs[index].type || 'homecare';
			const icon = {
				// pinDefault is 36 x 54
				url: `/assets/images/map/pin-${iconName}.png`,
				size: new google.maps.Size(27, 40),
				scaledSize: new google.maps.Size(27, 40),
				// scaled size of the pin icon
				// scaledSize: new google.maps.Size(18, 27),
				// The origin for this image is (0, 0).
				origin: new google.maps.Point(0, 0),
				// The anchor for this image is the base of the flagpole at (0, 32).
				// anchor: new google.maps.Point(18, 54),
			};
			let marker = new google.maps.Marker({
				position: this.gMapLatLangs[index],
				map: this.map,
				icon: icon,
			});
			let infoWindowDto = {
				url: this.latLangs[index].link,
				title: this.latLangs[index].title,
				summary: this.latLangs[index].summary,
				state: this.latLangs[index].state,
				suburb: this.latLangs[index].suburb,
				type: this.latLangs[index].type,
				imgUrl: this.latLangs[index].image,
			};

			this.initInfoWindow(this.map, marker, infoWindowDto, this.infoWindow_);

			return marker;
		});
		this.gMapLatLangs = [];
		this.latLangs = [];
	}

	initInfoWindow(map, marker, infoWindow, infoWindow_) {
		if (infoWindow === undefined) {
			return null;
		}

		let contentString = `
			<div class="${CLS}-infoWindow py-0">
				<div class="d-block d-md-flex">
					<div class="d-md-block overflow-hidden ${CLS}-infoWindow-img">
						<div class="bg-center bg-cover w-100 h-100 transition hover:scale-1" style="background-image: url(${infoWindow.imgUrl})"></div>
					</div>
					<div class="mt-2 mt-md-0 pl-md-2 position-relative">
						<a href="${infoWindow.url}">
							<h4 class="text-salmon">${infoWindow.title}, ${infoWindow.suburb}, ${infoWindow.state}</h4>
						</a>
						<div style="max-width:350px" class="">${infoWindow.summary}</div>`;
		contentString += `</div>
				</div>
			</div>
		`;
		let that = this;
		google.maps.event.addListener(marker, 'click', (function() {
			if (that.infoWindow_) {
				that.infoWindow_.close();
			}
			that.infoWindow_.setContent(contentString);
			that.infoWindow_.open(that.map, marker);

			// let newPos = new google.maps.LatLng(location.lat, location.lng);
			// reset the current marker as a center
			that.map.panTo(marker.location);
		}));
	}

	setMapInfoBlockSize() {
		let maxHeight = Math.max.apply(null, $(`.${CLS}-locationCard `).map(function() {
			return $(this).innerHeight();
		}).get());

		$(`.${CLS}-locationCard`).height(maxHeight);
	}

	initSelect2() {
		$(`${BLK}selectControl`).select2({
			// theme: 'bootstrap4',
			width: '100%',
			minimumResultsForSearch: -1,
			placeholder: "Select from state",
		});

		$(`${BLK}selectTypeControl`).select2({
			// theme: 'bootstrap4',
			width: '100%',
			minimumResultsForSearch: -1,
			placeholder: "Select from type",
		});
	}
}
